module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.15.3@axios/index.js
// module id = 400
// module chunks = 0 1 2 3 4 5 6 7 8 9 10